export default {
    noPermissionToAccessApp: 'You do not have permission to access this app.',
    App: 'App',
}